import _ from 'lodash';

import { deviceTypes, languages, operatingSystems } from '../constants';

export const buildOperatingSystemLabel = (os) => (
  _.map(os, (x) => operatingSystems[x]).join(', ')
);

export const deviceTypesLabel = (device) => deviceTypes[device];

export const getAudienceAttributeOptions = (audienceAtt, type) => {
  const audienceAttribute = _.find(audienceAtt, { audienceAttributeType: type });

  if (!audienceAttribute) {
    return 'Any';
  }

  const { audienceAttributeOptions } = audienceAttribute;

  return audienceAttributeOptions.map((option) => (option.name)).join(', ');
};

export const isUnitedStatesSelected = (audienceAttrs) => {
  const locationCountry = getAudienceAttributeOptions(audienceAttrs, 'location_country');
  return locationCountry === 'Any' || locationCountry.includes('us');
};

export const getLanguage = (languageValue) => (
  _.find(languages, (language) => language.value === languageValue).text
);
